import { Link } from "react-router-dom";
import Iconify from "../../ui/iconify/Iconify";
import PropTypes from "prop-types";

const RenderGridAction = ({ rowData, col, rowIndex, onActionHandler, allowEditGrid, isRowEditable, onEditRow }) => {

  if (!col.defaultAction) {
    col.defaultAction = {
      allowEdit: true,
      allowDelete: true,
    };
  }

  if (col.renderCustomAction) {
    col?.renderCustomAction(rowData, col);
  }

  const handleAction = (actionName, data, rowIndex) => {
    if (onActionHandler) {
      if (onActionHandler[actionName]) {
        onActionHandler[actionName](data, rowIndex);
      }
    }
  };

  // this method help user to check if row edit enable then allow to make it editable
  const handleRowEdit = (actionName, data, rowIndex) => {
    if (!isRowEditable && allowEditGrid) {
      if (onEditRow)
        onEditRow(rowIndex, data);
    }
    else {
      handleAction(actionName, data, rowIndex);
    }
  }

  const isEditingRow = allowEditGrid && isRowEditable;

  return (
    <div className="d-flex action-button">
      {!isEditingRow && col.customAction &&
        col.customAction.length > 0 &&
        col.customAction.map((action, index) => {
          const commonLinkProps = {
            key: `customAction_${index}`,
            onClick: (e) => {
              e.preventDefault();
              handleAction(action.name, rowData, rowIndex);
            },
            className: "mx-1",
            title: action.name,
            href: "",
          };
          // Add condition to check if rowData.contractInputFile is present
          if (action.name === "DOWNLOAD" && !rowData.contractInputFile) {
            return null;
          } else {
            // Render null if rowData.contractInputFile is not present
            return (
              <Link {...commonLinkProps}>
                <Iconify icon={action.iconClass || "basil:other-1-outline"} altText={action.name} />
              </Link>
            );
          }
        })}


      {/* Edit Action Button */}
      {col.defaultAction.allowEdit && (
        <Link
          onClick={(e) => {
            e.preventDefault();

            handleRowEdit("EDIT", rowData, rowIndex);
          }}
          className="mx-1"
          title="EDIT"
        >
          <Iconify icon={"bxs:edit"} altText={"Edit"} />
        </Link>
      )}

      {/* Delete Action Button */}
      {!isEditingRow && col.defaultAction.allowDelete && (
        <Link
          onClick={(e) => {
            e.preventDefault();
            handleAction("DELETE", rowData, rowIndex);
          }}
          className="mx-1"
          title="DELETE"
        >
          <Iconify icon={"ic:round-delete"} altText={"Delete"} />
        </Link>
      )}
    </div>
  );
};


RenderGridAction.propTypes = {
  rowData: PropTypes.object.isRequired,
  col: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  onActionHandler: PropTypes.object,
  allowEditGrid: PropTypes.bool.isRequired,
  isRowEditable: PropTypes.bool.isRequired,
  onEditRow: PropTypes.func,
};

export default RenderGridAction